import React, { useState, useEffect } from "react";
import { Alert, Table, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getFuncFichaEmpleado } from "../../redux/func_ficha_empleados/actions";
import CustomNavbar from "../../components/CustomNavbar";
import SidebarDashboard from "../../components/SidebarDashboard";
import UserHeadDetail from "../../components/UserHeadDetail";
import UserHeadDetailMenu from "../../components/UserHeadDetailMenu";
import moment from "moment";
import LinkDescargaListGD from "../../components/gestorDocumental/LinkDescargaListGD";
import config from "../../config";

const Education = (props) => {
  const dispatch = useDispatch();
  const data = useSelector((store) => store.funcTabEmployeed.ficha_empleado);
  const loading = useSelector(
    (store) => store.funcTabEmployeed.loadingFicha_Empleado
  );
  //const loadingRelationsShips = useSelector(store => store.relationship.loading);

  useEffect(() => {
    dispatch(
      getFuncFichaEmpleado(
        props.match.params.id,
        parseInt(props.match.params.type)
      )
    );
  }, [dispatch, props.match.params.id, props.match.params.type]);

  const [show, setShow] = useState(false);
  const onShowSidebar = () => setShow(show ? false : true);

  const { area, email } = config.gestorDocumental;
  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <div className="container mt-3 mb-3">
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            <>
              <UserHeadDetail data={data} type={props.match.params.type} />
              <div className="my-4">
                <UserHeadDetailMenu
                  id={props.match.params.id}
                  type={props.match.params.type}
                />
                <div className="mt-4 mb-3">
                  <div className="d-flex aling-items-center justify-content-between px-2">
                    {/* <h5 className="font-weight-bold text-uppercase">Educación</h5> */}
                    <h5 className="font-weight-bold text-uppercase">
                      F-655 REGISTRO CONTROL DE CAPACITACIONES INDIVIDUAL
                    </h5>
                    <div>
                      <span className="text-muted mr-3">
                        <i className="material-icons">perm_identity</i>{" "}
                        Identidad: {data.identidad}
                      </span>
                      <span className="text-muted">
                        <i className="material-icons">moving</i> Estado civil:{" "}
                        {data.Estado_Civil_List
                          ? data.Estado_Civil_List[0].nombre
                          : "No ingresado aún"}
                      </span>
                    </div>
                  </div>
                  <hr className="mb-3" />
                  <div className="mt-4 mb-3">
                    {data.Educacion_List ? (
                      <Table variant="dark">
                        <thead>
                          <tr>
                            <th scope="col">Título</th>
                            <th scope="col">Instituto</th>
                            <th scope="col">Especialidad</th>
                            <th scope="col">Descripción</th>
                            <th scope="col">Fecha de inicio</th>
                            <th scope="col">Fecha de fin</th>
                            <th scope="col">Documento</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.Educacion_List.map((item, id) => (
                            <tr key={item.id}>
                              <td>
                                {item.titulo_list
                                  ? item.titulo_list.descripcion
                                  : "No registrado aún"}
                              </td>
                              <td>
                                {item.instituto_list
                                  ? item.instituto_list.descripcion
                                  : "No registrado aún"}
                              </td>
                              <td>
                                {item.especialidad_list
                                  ? item.especialidad_list.descripcion
                                  : "No registrado aún"}
                              </td>
                              <td>
                                {item.formacion_list
                                  ? item.formacion_list.descripcion
                                  : "No registrado aún"}
                              </td>
                              <td>
                                {moment(item.fecha_inicio).format("DD/MM/YYYY")}
                              </td>
                              <td>
                                {moment(item.fecha_fin).format("DD/MM/YYYY")}
                              </td>
                              <td>
                                {data.Educacion_List[id].archivo_gestor ? (
                                  <LinkDescargaListGD
                                    id={id}
                                    filters={{
                                      email: email,
                                      id: data.Educacion_List[id]
                                        .archivo_gestor[0].id_documento,
                                      llave:
                                        data.Educacion_List[id]
                                          .archivo_gestor[0].llave,
                                    }}
                                    origen={
                                      data.Educacion_List[id].archivo_gestor[0]
                                        .origen
                                    }
                                    icono={
                                      <i className="material-icons">file</i>
                                    }
                                    cType={
                                      data.Educacion_List[id].archivo_gestor[0]
                                        .contentTypeGD
                                    }
                                  />
                                ) : (
                                  "No registrado aun"
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    ) : (
                      <Alert variant="info">
                        <p>No registrados aún</p>
                      </Alert>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};
export default Education;
